<div class="package-badge badge-{{ size }} {{ packageType?.toLowerCase() }}-package-badge">
  {{ packageName | subscriptionPlanTranslation }}
</div>
